module.exports = __webpack_public_path__ + "static/media/home.575878e0.png";